/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mTierBenefits.vue?vue&type=template&id=c97716e4"
import script from "./mTierBenefits.vue?vue&type=script&lang=js"
export * from "./mTierBenefits.vue?vue&type=script&lang=js"
import style0 from "./mTierBenefits.vue?vue&type=style&index=0&id=c97716e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports